// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* product grid start*/
.product-grid {
  background-color: #fff;
  position: relative;
  margin-bottom: 30px;
  transition: all 0.5s ease-in-out;
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.2);
}
.product-grid .product_img {
  position: relative;
  overflow: hidden;
}
.product-grid .product_img img {
  transition: all 0.3s ease-in-out;
}
.product:hover .product-grid .product_img img {
  transform: scale(1.1);
}
.product-grid .product_img::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.2);
  opacity: 0;
  transition: all 0.5s ease-in-out;
  z-index: 1;
}
:hover > .product-grid .product_img::before {
  opacity: 1;
}
.product-grid .product_img .product_action_box {
  position: absolute;
  top: 50%;
  left: 0;
  z-index: 2;
  right: 0;
  text-align: center;
  padding-top: 0;
  transition: all 0.5s ease-in-out;
  transform: translateY(-50%);
  opacity: 0;
}
:hover > .product-grid .product_img .product_action_box {
  opacity: 1;
}
.product-grid .product_img .pr_action_btn li {
  position: relative;
  margin: 0 5px;
  display: inline-block;
}
.product-grid .product_img .pr_action_btn li p {
  background-color: #fff;
  font-size: 0;
  text-transform: capitalize;
  transition: all 0.3s ease-in-out;
  width: 37px;
  height: 37px;
  text-align: center;
  cursor: pointer;
  position: relative;
  z-index: 1;
}
.product-grid .product_img .pr_action_btn li p:hover {
  background-color: #ff324d;
  color: #fff;
}
.product-grid .product_img .pr_action_btn li p i {
  vertical-align: middle;
  line-height: 37px;
  font-size: 18px;
}

/* responsive width for product */
.product-width {
  width: 32%;
}
@media (max-width: 1200px) {
  .product-width {
    width: 48%;
  }
}
@media (max-width: 768px) {
  .product-width {
    width: 100%;
  }
}

/* product grid end*/
.grid-layout {
  border: 1px solid;
  border-radius: 4px;
  padding: 4px 8px;
}

.active-grid-layout {
  border: 1px solid #ff324d;
  border-radius: 4px;
  padding: 4px 8px;
  background-color: #ff324d;
  color: #fff;
}

/* product row start */
.product-row {
  background-color: #fff;
  position: relative;
  margin-bottom: 30px;
  transition: all 0.5s ease-in-out;
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.2);
}
.product-row .product_img {
  width: 24%;
  height: 24%;
}
@media (max-width: 992px) {
  .product-row .product_img {
    width: 100%;
  }
}
.product-row .product_title span {
  font-size: 24px;
  cursor: pointer;
}
.product-row .product_title span:hover {
  color: #ff324d;
}
.product-row .list_product_action_box ul li {
  font-size: 18px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.product-row .list_product_action_box ul li p {
  margin: 0px;
  cursor: pointer;
}
.product-row .pr_desc p {
  font-size: 18px;
}

/* common   */
.product_color_switch {
  display: flex;
  align-items: center;
  gap: 5px;
}
.product_color_switch span {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-block;
  cursor: pointer;
  border: 1px solid #ddd;
}

.product_title {
  padding-top: 10px;
}
.product_title span {
  font-size: 24px;
  cursor: pointer;
}
.product_title span:hover {
  color: #ff324d;
}

.product_price {
  display: flex;
  align-items: center;
  gap: 10px;
}
.product_price .price {
  font-size: 24px;
  color: #ff324d;
  font-weight: 600;
}
.product_price del {
  color: gray;
  font-size: 18px;
}
.product_price .on_sale span {
  color: gray;
  font-size: 18px;
}

/* popmodule */
.pop-module .product-title p {
  font-size: 24px;
  margin: 0px;
  font-weight: 600;
  color: #000;
}
.pop-module .product-details span {
  font-size: 18px;
  margin: 0;
  color: #000;
}
.pop-module .product-details .price {
  display: block;
  color: #ff324d;
  font-size: 28px;
  font-weight: 600;
}

/* strar component */
.star {
  color: gray;
  transition: color 0.2s ease;
}

.star.filled {
  color: gold;
}

/* Rotating icon when the dropdown is open */
.category .still {
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
  transform: rotate(0deg);
}
.category .rotate {
  transition: transform 0.3s ease-in-out;
  transform: rotate(90deg);
}
.category .subcategory {
  cursor: pointer;
}
.category .subcategory:hover {
  color: #ff324d;
}

.brnad input {
  margin: 10px;
}

.size ul {
  display: flex;
  gap: 5px;
}
.size ul li {
  border: 1px solid #000;
  padding: 5px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/Pages/supplier_app/MaterialCatalogShopwies/Materialcatalog.scss"],"names":[],"mappings":"AAAA,sBAAA;AACA;EACE,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,sCAAA;AACF;AAAE;EACE,kBAAA;EACA,gBAAA;AAEJ;AADI;EACE,gCAAA;AAGN;AAFM;EACE,qBAAA;AAIR;AADI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,MAAA;EACA,oCAAA;EACA,UAAA;EACA,gCAAA;EACA,UAAA;AAGN;AADI;EACE,UAAA;AAGN;AADI;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,QAAA;EACA,kBAAA;EACA,cAAA;EACA,gCAAA;EACA,2BAAA;EACA,UAAA;AAGN;AAFM;EACE,UAAA;AAIR;AAAM;EACE,kBAAA;EACA,aAAA;EACA,qBAAA;AAER;AADQ;EACE,sBAAA;EACA,YAAA;EACA,0BAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;AAGV;AAFU;EACE,yBAAA;EACA,WAAA;AAIZ;AAFU;EACE,sBAAA;EACA,iBAAA;EACA,eAAA;AAIZ;;AAGA,iCAAA;AACA;EACE,UAAA;AAAF;AACE;EAFF;IAGI,UAAA;EAEF;AACF;AADE;EALF;IAMI,WAAA;EAIF;AACF;;AAFA,oBAAA;AAGA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;AAGF;;AADA;EACC,yBAAA;EACG,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;AAIJ;;AADA,sBAAA;AACA;EACE,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,sCAAA;AAIF;AAHE;EACE,UAAA;EACA,WAAA;AAKJ;AAJI;EAHF;IAII,WAAA;EAOJ;AACF;AAJI;EACE,eAAA;EACA,eAAA;AAMN;AALM;EACE,cAAA;AAOR;AADM;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAGR;AADQ;EACE,WAAA;EACA,eAAA;AAGV;AAGI;EACE,eAAA;AADN;;AAKA,aAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAFF;AAGE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,sBAAA;AADJ;;AAIA;EACE,iBAAA;AADF;AAEE;EACE,eAAA;EACA,eAAA;AAAJ;AACI;EACE,cAAA;AACN;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAAF;AAEE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAAJ;AAEE;EACE,WAAA;EACA,eAAA;AAAJ;AAGI;EACE,WAAA;EACA,eAAA;AADN;;AAMA,cAAA;AAGI;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;AALN;AASI;EACE,eAAA;EACA,SAAA;EACA,WAAA;AAPN;AASI;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAPN;;AAWA,oBAAA;AACA;EACE,WAAA;EACA,2BAAA;AARF;;AAWA;EACE,WAAA;AARF;;AAWA,4CAAA;AAEE;EACE,eAAA;EACA,sCAAA;EACA,uBAAA;AATJ;AAWE;EACE,sCAAA;EACA,wBAAA;AATJ;AAWE;EACE,eAAA;AATJ;AAUI;EACE,cAAA;AARN;;AAaE;EACE,YAAA;AAVJ;;AAcE;EACE,aAAA;EACA,QAAA;AAXJ;AAYI;EACE,sBAAA;EACA,YAAA;EACA,eAAA;AAVN","sourcesContent":["/* product grid start*/\n.product-grid {\n  background-color: #fff;\n  position: relative;\n  margin-bottom: 30px;\n  transition: all 0.5s ease-in-out;\n  box-shadow: 0 0 7px rgba(0, 0, 0, 0.2);\n  .product_img {\n    position: relative;\n    overflow: hidden;\n    img {\n      transition: all 0.3s ease-in-out;\n      .product:hover & {\n        transform: scale(1.1);\n      }\n    }\n    &::before {\n      content: \"\";\n      position: absolute;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      top: 0;\n      background-color: rgba(0, 0, 0, 0.2);\n      opacity: 0;\n      transition: all 0.5s ease-in-out;\n      z-index: 1;\n    }\n    :hover > &::before {\n      opacity: 1;\n    }\n    .product_action_box {\n      position: absolute;\n      top: 50%;\n      left: 0;\n      z-index: 2;\n      right: 0;\n      text-align: center;\n      padding-top: 0;\n      transition: all 0.5s ease-in-out;\n      transform: translateY(-50%);\n      opacity: 0; // Initially hidden\n      :hover > & {\n        opacity: 1;\n      }\n    }\n    .pr_action_btn {\n      li {\n        position: relative;\n        margin: 0 5px;\n        display: inline-block;\n        p {\n          background-color: #fff;\n          font-size: 0;\n          text-transform: capitalize;\n          transition: all 0.3s ease-in-out;\n          width: 37px;\n          height: 37px;\n          text-align: center;\n          cursor: pointer;\n          position: relative;\n          z-index: 1;\n          &:hover {\n            background-color: #ff324d;\n            color: #fff;\n          }\n          i {\n            vertical-align: middle;\n            line-height: 37px;\n            font-size: 18px;\n          }\n        }\n      }\n    }\n  }\n}\n/* responsive width for product */\n.product-width {\n  width: 32%;\n  @media (max-width: 1200px) {\n    width: 48%;\n  }\n  @media (max-width: 768px) {\n    width: 100%;\n  }\n}\n/* product grid end*/\n\n\n.grid-layout {\n  border: 1px solid;\n  border-radius: 4px;\n  padding: 4px 8px;\n}\n.active-grid-layout {\n\tborder: 1px solid #ff324d;\n    border-radius: 4px;\n    padding: 4px 8px;\n    background-color: #ff324d;\n    color: #fff;\n}\n\n/* product row start */\n.product-row {\n  background-color: #fff;\n  position: relative;\n  margin-bottom: 30px;\n  transition: all 0.5s ease-in-out;\n  box-shadow: 0 0 7px rgba(0, 0, 0, 0.2);\n  .product_img {\n    width: 24%; // Default for large screens\n    height: 24%;\n    @media (max-width: 992px) {\n      width: 100%; // Full width on small screens\n    }\n  }\n  .product_title {\n    span {\n      font-size: 24px;\n      cursor: pointer;\n      &:hover {\n        color: #ff324d;\n      }\n    }\n  }\n  .list_product_action_box {\n    ul {\n      li {\n        font-size: 18px;\n        display: flex;\n        align-items: center;\n        cursor: pointer;\n\n        p {\n          margin: 0px;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n  .pr_desc {\n    p {\n      font-size: 18px;\n    }\n  }\n}\n/* common   */\n.product_color_switch {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  span {\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    display: inline-block;\n    cursor: pointer;\n    border: 1px solid #ddd;\n  }\n}\n.product_title {\n  padding-top: 10px;\n  span {\n    font-size: 24px;\n    cursor: pointer;\n    &:hover {\n      color: #ff324d;\n    }\n  }\n}\n.product_price {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  // padding: 10px 0px;\n  .price {\n    font-size: 24px;\n    color: #ff324d;\n    font-weight: 600;\n  }\n  del {\n    color: gray;\n    font-size: 18px;\n  }\n  .on_sale {\n    span {\n      color: gray;\n      font-size: 18px;\n    }\n  }\n}\n\n/* popmodule */\n.pop-module {\n  .product-title {\n    p {\n      font-size: 24px;\n      margin: 0px;\n      font-weight: 600;\n      color: #000;\n    }\n  }\n  .product-details {\n    span {\n      font-size: 18px;\n      margin: 0;\n      color: #000;\n    }\n    .price {\n      display: block;\n      color: #ff324d;\n      font-size: 28px;\n      font-weight: 600;\n    }\n  }\n}\n/* strar component */\n.star {\n  color: gray;\n  transition: color 0.2s ease;\n}\n\n.star.filled {\n  color: gold;\n}\n\n/* Rotating icon when the dropdown is open */\n.category {\n  .still {\n    cursor: pointer;\n    transition: transform 0.3s ease-in-out;\n    transform: rotate(0deg);\n  }\n  .rotate {\n    transition: transform 0.3s ease-in-out;\n    transform: rotate(90deg);\n  }\n  .subcategory {\n    cursor: pointer;\n    &:hover {\n      color: #ff324d;\n    }\n  }\n}\n.brnad {\n  input {\n    margin: 10px;\n  }\n}\n.size {\n  ul {\n    display: flex;\n    gap: 5px;\n    li {\n      border: 1px solid #000;\n      padding: 5px;\n      cursor: pointer;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
